angular.module('psModule').factory('premiumService', ['$resource',
    function($resource) {
        return $resource('/ps/api/premium', {}, {
            getPremiums: {method: 'GET', params: {}, isArray: true}
        });
    }
]);
